// eslint-disable-next-line boundaries/dependencies -- Shared locale contracts live in the types package.
import type { GeckoLocale } from 'types'
import {
  isSiteLanguage,
  type SiteLanguage,
  // eslint-disable-next-line boundaries/dependencies -- Reuse the site-config language guard instead of duplicating supported languages.
} from 'types/entries/geckoSiteConfig'

export type GeckoLanguage = SiteLanguage

export const LANGUAGE_STORAGE_KEY = 'language'

export const isGeckoLanguage = isSiteLanguage

const localeByLanguage: Record<GeckoLanguage, GeckoLocale> = {
  en: 'en-US',
  es: 'es-419',
}

const languageByLocale: Record<GeckoLocale, GeckoLanguage> = {
  'en-US': 'en',
  'es-419': 'es',
}

export const localeForLanguage = (language: GeckoLanguage): GeckoLocale =>
  localeByLanguage[language]

export const languageForLocale = (locale: GeckoLocale): GeckoLanguage =>
  languageByLocale[locale]

/** A saved user preference wins; otherwise English is used until the site loads. */
export const resolveInitialLocale = ({
  storedLanguage,
}: {
  storedLanguage: string | null
}): GeckoLocale => {
  if (storedLanguage !== null && isGeckoLanguage(storedLanguage)) {
    return localeForLanguage(storedLanguage)
  }
  return 'en-US'
}
